import React, { Fragment } from "react";

interface propsTypes {
  children?: React.ReactNode;
  className?:string;
  color?:string
}

const Ribbon = (props: propsTypes) => {
  const { children, ...res } = props;
  return (
    <Fragment>
      <div {...res}>{children}</div>
    </Fragment>
  );
};

export default Ribbon;
